<template>
  <v-row>
    <v-col cols="12" class="mt-4">
      <v-sheet
        outlined>
  
        <v-row class="pa-4">
  
          <v-col cols="12">
            <h3>Emprendimientos:</h3>
          </v-col>
  
          <v-col cols="12" xl="3" md="3" sm="12">
            <v-sheet
              outlined
              :elevation="(type_postulation_id=='all') ? 10 : 0"
              :color="(type_postulation_id=='all') ? 'cyan lighten-5' : 'none'"
              class="elevated-sheet"
              height="160px"
              @click="selectEntrepreneurshipsType('all')"
              style="cursor:pointer;">
              <v-row class="pa-2">
                <v-col cols="6">
                  <v-img 
                    alt="UNL" 
                    contain
                    height="80px"
                    :src="require('@/assets/img/toppng.com-rocket.png')">
                  </v-img>
                </v-col>
                
                <v-col cols="6" class="d-flex align-center justify-center">
                  <h1 class="text-center">{{ entrepreneurships_count }}</h1>
                </v-col>
  
                <v-col cols="12">
                  <h4 class="text-center">Emprendimientos</h4>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>
  
          <v-col cols="12" xl="3" md="3" sm="12">
            <v-sheet
              outlined
              :elevation="(type_postulation_id==1) ? 10 : 0"
              :color="(type_postulation_id==1) ? 'light-blue lighten-5' : 'none'"
              class="elevated-sheet"
              height="160px"
              @click="selectEntrepreneurshipsType('idea-project')"
              style="cursor:pointer;">
              <v-row class="pa-2">
                <v-col cols="6">
                  <v-img 
                    alt="UNL" 
                    contain
                    height="80px"
                    :src="require('@/assets/img/project_idea.png')">
                  </v-img>
                </v-col>
                
                <v-col cols="6" class="d-flex align-center justify-center">
                  <h1 class="text-center">{{ entrepreneurships_ip_count }}</h1>
                </v-col>
  
                <v-col cols="12">
                  <h4 class="text-center">Idea Proyecto</h4>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>
  
          <v-col cols="12" xl="3" md="3" sm="12">
            <v-sheet
              outlined
              :elevation="(type_postulation_id==2) ? 10 : 0"
              :color="(type_postulation_id==2) ? 'light-blue lighten-5' : 'none'"
              class="elevated-sheet"
              @click="selectEntrepreneurshipsType('idea-project-school')"
              style="cursor:pointer;"
              height="160px">
              <v-row class="pa-2">
                <v-col cols="6">
                  <v-img 
                    alt="UNL" 
                    contain
                    height="80px"
                    :src="require('@/assets/img/entrepreneurship_ico.png')">
                  </v-img>
                </v-col>
                
                <v-col cols="6" class="d-flex align-center justify-center">
                  <h1 class="text-center">{{ entrepreneurships_ip_school_count }}</h1>
                </v-col>
  
                <v-col cols="12">
                  <h4 class="text-center">IP Escuelas</h4>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>
  
          <v-col cols="12" xl="3" md="3" sm="12">
            <v-sheet
              outlined
              :elevation="(type_postulation_id==3) ? 10 : 0"
              :color="(type_postulation_id==3) ? 'light-blue lighten-5' : 'none'"
              class="elevated-sheet"
              @click="selectEntrepreneurshipsType('mdn')"
              style="cursor:pointer;"
              height="160px">
              <v-row class="pa-2">
                <v-col cols="6">
                  <v-img 
                    alt="UNL" 
                    contain
                    height="80px"
                    :src="require('@/assets/img/busness_models.png')">
                  </v-img>
                </v-col>
                
                <v-col cols="6" class="d-flex align-center justify-center">
                  <h1 class="text-center">{{ entrepreneurships_mdn_count }}</h1>
                </v-col>
  
                <v-col cols="12">
                  <h4 class="text-center">MDN</h4>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>
  
    <v-col cols="12">
      <v-sheet
        outlined>
        <v-row class="pa-4">
          
          <v-col cols="12">
            <h4>Stands:</h4>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12">
            <v-sheet
              outlined
              height="100px">
              <v-row class="pa-2">
                
                <v-col cols="12" class="d-flex align-center justify-center">
                  <h2 class="text-center">{{ entrepreneurships_published_count }}</h2>
                </v-col>
  
                <v-col cols="12">
                  <h4 class="text-center">Publicados</h4>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>
  
          <v-col cols="12" xl="4" md="4" sm="12">
            <v-sheet
              outlined
              height="100px">
              <v-row class="pa-2">
                
                <v-col cols="12" class="d-flex align-center justify-center">
                  <h2 class="text-center">{{ entrepreneurships_no_published_count }}</h2>
                </v-col>
  
                <v-col cols="12">
                  <h4 class="text-center">No publicados</h4>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>
  
          <v-col cols="12" xl="4" md="4" sm="12">
            <v-sheet
              outlined
              height="100px">
              <v-row class="pa-2">
                
                <v-col cols="12" class="d-flex align-center justify-center">
                  <h2 class="text-center">{{ entrepreneurships_bloked_count }}</h2>
                </v-col>
  
                <v-col cols="12">
                  <h4 class="text-center">Bloqueados</h4>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>
  
    <v-col cols="12">
      <v-sheet
        outlined
        color="error">
        <p class="white--text d-flex align-center justify-center pt-2 pl-2 pr-2">
          ¡ATENCIÓN!, los siguientes indicadores corresponden a los emprendimientos publicados, 
          es decir, aquellos que publicaron sus respectivos stands.  
        </p>
      </v-sheet>
    </v-col>

    <v-col cols="12">
      <v-sheet
        outlined
        v-if="!loading">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Emprendimientos por País:</h4>
          </v-col>
  
          <v-col cols="12">  
            <apexchart 
              type="bar" 
              height="400" 
              :options="entrepreneurships_countries_chart_options" 
              :series="entrepreneurships_countries_series">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12">
      <v-sheet
        outlined
        v-if="!loading">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Emprendimientos de Argentina:</h4>
          </v-col>
  
          <v-col cols="12">
            <apexchart 
              type="bar" 
              height="400" 
              :options="entrepreneurships_provincia_chart_options" 
              :series="entrepreneurships_provincia_series">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" xl="6" md="6" sm="12">  
      <v-sheet
        outlined
        height="500" 
        v-if="!loading">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Emprendimientos por vertical de trabajo:</h4>
          </v-col>
  
          <v-col cols="12">
            <apexchart 
              type="bar" 
              height="400" 
              :options="entrepreneurships_vertical_work_chart_options" 
              :series="entrepreneurships_vertical_work_series">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" xl="6" md="6" sm="12">  
      <v-sheet
        outlined
        height="500" 
        v-if="!loading">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Emprendimientos por vertical de trabajo (%):</h4>
          </v-col>
  
          <v-col cols="12">
            <apexchart
              class="pt-8"
              type="pie" 
              height="390"
              :options="entrepreneurships_vertical_work_series_pie_options" 
              :series="entrepreneurships_vertical_work_series[0].data">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" v-if="type_postulation_id==1">
      <v-sheet
        outlined
        v-if="!loading">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Grado de desarrollo Ideas Proyectos:</h4>
          </v-col>
  
          <v-col cols="12">
            <apexchart 
              type="bar" 
              height="400" 
              :options="entrepreneurships_development_degree_ip_chart_options" 
              :series="entrepreneurships_development_degree_ip_series">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" v-if="type_postulation_id==2">
      <v-sheet
        outlined
        v-if="!loading">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Grado de desarrollo Ideas Proyectos Escuelas:</h4>
          </v-col>
  
          <v-col cols="12">
            <apexchart 
              type="bar" 
              height="400" 
              :options="entrepreneurships_development_degree_ip_school_chart_options" 
              :series="entrepreneurships_development_degree_ip_school_series">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" xl="6" md="6" sm="12" v-if="type_postulation_id==3">
      <v-sheet
        outlined
        height="500" 
        v-if="!loading">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Grado de desarrollo Modelos de Negocio:</h4>
          </v-col>
  
          <v-col cols="12">
            <apexchart 
              type="bar" 
              height="400" 
              :options="entrepreneurships_development_degree_mdn_chart_options" 
              :series="entrepreneurships_development_degree_mdn_series">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" xl="6" md="6" sm="12" v-if="type_postulation_id=='all'">
      <v-sheet
        outlined
        v-if="!loading">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Grado de desarrollo:</h4>
          </v-col>
  
          <v-col cols="12">
            <apexchart 
              type="bar" 
              height="400" 
              :options="entrepreneurships_development_degree_chart_options" 
              :series="entrepreneurships_development_degree_series">
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>


    <v-col cols="12" xl="6" md="6" sm="12" v-if="type_postulation_id=='all'||type_postulation_id==3">
      <v-sheet
        outlined
        height="500" 
        v-if="!loading">
        <v-row>
          <v-col cols="12" class="pa-8">
            <h4>Estadios de los proyectos MDN(%):</h4>
          </v-col>
  
          <v-col cols="12">
            <apexchart
              class="pt-8"
              type="pie" 
              height="390"
              :options="entrepreneurships_stadia_mdn_series_pie_options" 
              :series="entrepreneurships_stadia_mdn_series[0].data">>
            </apexchart>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'entrepreneurshipsIndicator',

    props:['edition_id'],
    data: () => ({
      loading:true,

      type_postulation_id:'all',
      type_entrepreneurial_id: 'all',

      entrepreneurships_count:0,
      entrepreneurships_ip_count:0,
      entrepreneurships_ip_school_count:0,
      entrepreneurships_mdn_count:0,

      entrepreneurships_published_count:0,
      entrepreneurships_no_published_count:0,
      entrepreneurships_bloked_count:0,

      entrepreneurships_countries_count:0,
      entrepreneurships_countries_chart_options: {
        name: 'Paises',
        plotOptions: {
          bar: {
            borderRadius: 6,
          }
        },
        colors: ['#33b2df'],
        xaxis: {
          categories: []
        }
      },
      entrepreneurships_countries_series: [
        {
          name: 'Emprendimientos',
          data: []
        }
      ],

      entrepreneurships_provincia_count:0,
      entrepreneurships_provincia_chart_options: {
        name: 'Provincias',
        plotOptions: {
          bar: {
            borderRadius: 6,
          }
        },
        colors: ['#33b2df'],
        xaxis: {
          categories: []
        }
      },
      entrepreneurships_provincia_series: [
        {
          name: 'Emprendimientos',
          data: []
        }
      ],
      
      entrepreneurships_vertical_work_count:0,
      entrepreneurships_vertical_work_chart_options: {
        name: 'Vertical de trabajo',
        plotOptions: {
          bar: {
            borderRadius: 6,
          }
        },
        colors: ['#33b2df'],
        xaxis: {
          categories: []
        }
      },
      entrepreneurships_vertical_work_series: [
        {
          name: 'Emprendimientos',
          data: []
        }
      ],
      entrepreneurships_vertical_work_series_pie_options: {
        chart: {
          type: "pie",
        },
        labels: [],
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
        },
      },

      entrepreneurships_development_degree_count:0,
      entrepreneurships_development_degree_chart_options: {
        name: 'Grado de desarrollo',
        plotOptions: {
          bar: {
            borderRadius: 6,
          }
        },
        colors: ['#33b2df'],
        xaxis: {
          categories: []
        }
      },
      entrepreneurships_development_degree_series: [
        {
          name: 'Emprendimientos',
          data: []
        }
      ],

      entrepreneurships_development_degree_ip_count:0,
      entrepreneurships_development_degree_ip_chart_options: {
        name: 'Grado de desarrollo',
        plotOptions: {
          bar: {
            borderRadius: 6,
          }
        },
        colors: ['#33b2df'],
        xaxis: {
          categories: []
        }
      },
      entrepreneurships_development_degree_ip_series: [
        {
          name: 'Emprendimientos',
          data: []
        }
      ],

      entrepreneurships_development_degree_ip_school_count:0,
      entrepreneurships_development_degree_ip_school_chart_options: {
        name: 'Grado de desarrollo',
        plotOptions: {
          bar: {
            borderRadius: 6,
          }
        },
        colors: ['#33b2df'],
        xaxis: {
          categories: []
        }
      },
      entrepreneurships_development_degree_ip_school_series: [
        {
          name: 'Emprendimientos',
          data: []
        }
      ],

      entrepreneurships_development_degree_mdn_count:0,
      entrepreneurships_development_degree_mdn_chart_options: {
        name: 'Grado de desarrollo',
        plotOptions: {
          bar: {
            borderRadius: 6,
          }
        },
        colors: ['#33b2df'],
        xaxis: {
          categories: []
        }
      },
      entrepreneurships_development_degree_mdn_series: [
        {
          name: 'Emprendimientos',
          data: []
        }
      ],

      entrepreneurships_stadia_mdn_count:0,
      entrepreneurships_stadia_mdn_series: [
        {
          name: 'Emprendimientos',
          data: []
        }
      ],
      entrepreneurships_stadia_mdn_series_pie_options: {
        chart: {
          type: "pie",
        },
        labels: [],
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
        },
      },

    }),
    methods:{
      async getEntrepreneurships()
      {
        await axios.get('admin/indicators/entrepreneurships/'+this.edition_id).then(response =>{
          this.entrepreneurships_count = response.data.data.entrepreneurships_count
          this.entrepreneurships_ip_count = response.data.data.entrepreneurships_ip_count
          this.entrepreneurships_ip_school_count = response.data.data.entrepreneurships_ip_school_count
          this.entrepreneurships_mdn_count = response.data.data.entrepreneurships_mdn_count
          this.show=true
        }).catch(error => {
          console.log(error);
        })
      },

      selectEntrepreneurshipsType(type_postulation){
        switch (type_postulation) {
          case 'all':
            this.type_postulation_id='all';
            break;
          case 'idea-project':
            this.type_postulation_id=1;
            break;
          case 'idea-project-school':
            this.type_postulation_id=2;
            break;
          case 'mdn':
            this.type_postulation_id=3;
            break;
          default:
            this.type_postulation_id='all';
            break;
        }
        this.updateData()
      },

      async updateData(){
        this.loading = true
        Promise.all([
          this.getEntrepreneurships(),
          this.getEntrepreneurshipsType(),
          this.getEntrepreneurshipsCountries(),
          this.getEntrepreneurshipsCountriesArgentina(),
          this.getEntrepreneurshipsVerticalWorks(),
          this.getEntrepreneurshipsDevelopmentDegreeIP(),
          this.getEntrepreneurshipsDevelopmentDegreeIPSchools(),
          this.getEntrepreneurshipsDevelopmentDegreeMDN(),
          this.getEntrepreneurshipsStadiaMDN()
        ]).then(() => {
          this.loading = false
        }).catch((error) => {
          console.log(error)
        });
      },
      
      async getEntrepreneurshipsType()
      {
        await axios.get('admin/indicators/entrepreneurships/'+this.edition_id+'/'+this.type_postulation_id).then(response =>{
          this.entrepreneurships_published_count = response.data.data.entrepreneurships_published_count
          this.entrepreneurships_no_published_count = response.data.data.entrepreneurships_no_published_count
          this.entrepreneurships_bloked_count = response.data.data.entrepreneurships_bloked_count
        }).catch(error => {
          console.log(error);
        })
      },

      async getEntrepreneurshipsCountries()
      {
        this.entrepreneurships_countries_chart = false
        this.entrepreneurships_countries_chart_options.xaxis.categories = []
        this.entrepreneurships_countries_series[0].data = []

        let url = 'admin/indicators/entrepreneurships/'+this.edition_id+'/countries/'+this.type_postulation_id+'/type-postulation'

        await axios.get(url).then(response =>{
          this.entrepreneurships_countries_count = response.data.data.entrepreneurships_countries_count

          this.entrepreneurships_countries_count.forEach(element => {

          this.entrepreneurships_countries_chart_options.xaxis.categories.push( Object.keys(element)[0] )
          this.entrepreneurships_countries_series[0].data.push( Object.values(element)[0] )

          });

          this.entrepreneurships_countries_chart = true
        }).catch(error => {
          console.log(error);
        })
      },

      async getEntrepreneurshipsCountriesArgentina()
      {
        this.entrepreneurships_provincia_chart = false
        this.entrepreneurships_provincia_chart_options.xaxis.categories = []
        this.entrepreneurships_provincia_series[0].data = []

        let url = 'admin/indicators/entrepreneurships/'+this.edition_id+'/argentina/provincias/'+this.type_postulation_id+'/type-postulation'

        await axios.get(url).then(response =>{
          this.entrepreneurships_provincia_count = response.data.data.entrepreneurships_provincia_count

          this.entrepreneurships_provincia_count.forEach(element => {

            this.entrepreneurships_provincia_chart_options.xaxis.categories.push( Object.keys(element)[0] )
            this.entrepreneurships_provincia_series[0].data.push( Object.values(element)[0] )
          
          });

          this.entrepreneurships_provincia_chart = true

        }).catch(error => {
          console.log(error);
        })
      },

      async getEntrepreneurshipsVerticalWorks()
      {
        this.entrepreneurships_vertical_work_chart = false
        this.entrepreneurships_vertical_work_chart_options.xaxis.categories = []
        this.entrepreneurships_vertical_work_series_pie_options.labels = []
        this.entrepreneurships_vertical_work_series[0].data = []

        let url = 'admin/indicators/entrepreneurships/'+this.edition_id+'/vertical-works/'+this.type_postulation_id+'/type-postulation'
        
        await axios.get(url).then(response =>{
          this.entrepreneurships_vertical_work_count = response.data.data.entrepreneurships_vertical_work_count

          this.entrepreneurships_vertical_work_count.forEach(element => {

            this.entrepreneurships_vertical_work_chart_options.xaxis.categories.push( Object.keys(element)[0] )
            this.entrepreneurships_vertical_work_series_pie_options.labels.push( Object.keys(element)[0] )
            this.entrepreneurships_vertical_work_series[0].data.push( Object.values(element)[0] )
          
          });

          this.entrepreneurships_vertical_work_chart = true

        }).catch(error => {
          console.log(error);
        })
      },

      async getEntrepreneurshipsDevelopmentDegree()
      {
        this.entrepreneurships_development_degree_chart = false
        this.entrepreneurships_development_degree_chart_options.xaxis.categories = []
        this.entrepreneurships_development_degree_series[0].data = []

        let url = 'admin/indicators/entrepreneurships/'+this.edition_id+'/all/development-degree'

        await axios.get(url).then(response =>{
          this.entrepreneurships_development_degre_count = response.data.data.entrepreneurships_development_degree_count

          this.entrepreneurships_development_degre_count.forEach(element => {

            this.entrepreneurships_development_degree_chart_options.xaxis.categories.push( Object.keys(element)[0] )
            this.entrepreneurships_development_degree_series[0].data.push( Object.values(element)[0] )
          
          });

          this.entrepreneurships_development_degre_chart = true

        }).catch(error => {
          console.log(error);
        })
      },

      async getEntrepreneurshipsDevelopmentDegreeIP()
      {
        this.entrepreneurships_development_degree_ip_chart = false
        this.entrepreneurships_development_degree_ip_chart_options.xaxis.categories = []
        this.entrepreneurships_development_degree_ip_series[0].data = []

        let url = 'admin/indicators/entrepreneurships/'+this.edition_id+'/2/development-degree'

        await axios.get(url).then(response =>{
          this.entrepreneurships_development_degree_ip_count = response.data.data.entrepreneurships_development_degree_count

          this.entrepreneurships_development_degree_ip_count.forEach(element => {

            this.entrepreneurships_development_degree_ip_chart_options.xaxis.categories.push( Object.keys(element)[0] )
            this.entrepreneurships_development_degree_ip_series[0].data.push( Object.values(element)[0] )
          
          });

          this.entrepreneurships_development_degree_ip_chart = true

        }).catch(error => {
          console.log(error);
        })
      },

      async getEntrepreneurshipsDevelopmentDegreeIPSchools()
      {
        this.entrepreneurships_development_degree_ip_school_chart = false
        this.entrepreneurships_development_degree_ip_school_chart_options.xaxis.categories = []
        this.entrepreneurships_development_degree_ip_school_series[0].data = []

        let url = 'admin/indicators/entrepreneurships/'+this.edition_id+'/2/development-degree'
        
        await axios.get(url).then(response =>{
          this.entrepreneurships_development_degree_ip_school_count = response.data.data.entrepreneurships_development_degree_count

          this.entrepreneurships_development_degree_ip_school_count.forEach(element => {

            this.entrepreneurships_development_degree_ip_school_chart_options.xaxis.categories.push( Object.keys(element)[0] )
            this.entrepreneurships_development_degree_ip_school_series[0].data.push( Object.values(element)[0] )
          
          });

          this.entrepreneurships_development_degree_ip_school_chart = true

        }).catch(error => {
          console.log(error);
        })
      },

      async getEntrepreneurshipsDevelopmentDegreeMDN()
      {

        this.entrepreneurships_development_degree_mdn_chart = false
        this.entrepreneurships_development_degree_mdn_chart_options.xaxis.categories = []
        this.entrepreneurships_development_degree_mdn_series[0].data = []

        let url = 'admin/indicators/entrepreneurships/'+this.edition_id+'/3/development-degree'
        
        await axios.get(url).then(response =>{
          this.entrepreneurships_development_degree_mdn_count = response.data.data.entrepreneurships_development_degree_count

          this.entrepreneurships_development_degree_mdn_count.forEach(element => {

            this.entrepreneurships_development_degree_mdn_chart_options.xaxis.categories.push( Object.keys(element)[0] )
            this.entrepreneurships_development_degree_mdn_series[0].data.push( Object.values(element)[0] )
          
          });

          this.entrepreneurships_development_degree_mdn_chart = true

        }).catch(error => {
          console.log(error);
        })
      },

      async getEntrepreneurshipsStadiaMDN()
      {
        this.entrepreneurships_stadia_mdn_series_pie_options.labels = []
        this.entrepreneurships_stadia_mdn_series[0].data = []

        let url = 'admin/indicators/entrepreneurships/'+this.edition_id+'/development-degree/mdn/stadia'
        
        await axios.get(url).then(response =>{
          this.entrepreneurships_stadia_mdn_count = response.data.data.entrepreneurships_stadia_mdn_count

          this.entrepreneurships_stadia_mdn_count.forEach(element => {
            this.entrepreneurships_stadia_mdn_series_pie_options.labels.push( Object.keys(element)[0] )
            this.entrepreneurships_stadia_mdn_series[0].data.push( Object.values(element)[0] )
          });
        }).catch(error => {
          console.log(error);
        })
      },

    },
    created(){
      Promise.all([
        this.getEntrepreneurships(),
        this.getEntrepreneurshipsType(),
        this.getEntrepreneurshipsCountries(),
        this.getEntrepreneurshipsCountriesArgentina(),
        this.getEntrepreneurshipsVerticalWorks(),
        this.getEntrepreneurshipsDevelopmentDegree(),
        this.getEntrepreneurshipsDevelopmentDegreeIP(),
        this.getEntrepreneurshipsDevelopmentDegreeIPSchools(),
        this.getEntrepreneurshipsDevelopmentDegreeMDN(),
        this.getEntrepreneurshipsStadiaMDN()
      ]).then(() => {
        this.loading = false
      }).catch((error) => {
        console.log(error)
      });
    },
  }
</script>
<style scoped>
.apexcharts-legend {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>